module.exports = __webpack_public_path__ + "static/media/edit.1b71f396.svg";